<template>
    <a-modal :title="modelTitle"
             :width="600"
             :visible="visible"
             :maskClosable="false"
             @cancel="handleCancel"
             @ok="handleOk"
             destroyOnClose
             :confirmLoading="loading"
             :footer="null"
    >
        <a-form :form="form" class="custom pick-100 form-input">
            <a-row v-show="caseId && caseId !== ''" style="margin: 8px;">
                <a-col :span="24">
                    <a-form-item label="相关附件" type="deployment-unit">
                        <!-- 流程编辑权限 或 附件超级管理权限 -->
                        <upload-selector :referId="caseId" :selfUpdate="!(xwfState.hasEdit || user.permissions['system.manage'])" :isAllCase="true" :notConfigKeys="notConfigKeys" configKey="case"/>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
    </a-modal>
</template>

<script>
import qs from 'qs'
import UploadSelector from '@/components/selector/UploadSelector'

const notConfigKeys = ['RECEIVE.DOC', 'DISPATCH.DOC', 'DRAFT.DOC']

export default {
  name: 'WorkflowCaseAttachMgr',
  components: {
    UploadSelector
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caseId: {
      type: String,
      default: ''
    },
    fileKey: {
      type: String,
      default: ''
    },
    modelTitle: {
      type: String,
      default: '附件管理'
    }
  },
  created () {
  },
  data () {
    return {
      user: this.$ls.get('user'),
      form: this.$form.createForm(this),
      loading: false,
      xwfState: { },
      notConfigKeys
    }
  },
  methods: {
    preData ($xwfState) {
      const that = this

      this.xwfState = $xwfState
      this.caseId = this.xwfState.caseId
      // var params = {
      //   caseId: this.xwfState.caseId
      // }
      // that.$http.get('/api/1/doc/file/get_file.json?' + qs.stringify(params)).then(function (resp) {
      //   that.fileId = resp.result
      // })
    },
    handleOk () {
      this.$emit('success')
    },
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="less" scoped>

</style>
